import React from 'react';

const FacebookIcon: React.FC = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="facebook-mask" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
        <path d="M15.9996 0.179688H0V16.1793H15.9996V0.179688Z" fill="white" />
      </mask>
      <g mask="url(#facebook-mask)">
        <path
          d="M11.4756 9.06528L11.8902 6.33526H9.29666V4.56444C9.29666 3.81737 9.65829 3.08875 10.8199 3.08875H11.9998V0.764539C11.9998 0.764539 10.9295 0.580078 9.90669 0.580078C7.76976 0.580078 6.37437 1.88791 6.37437 4.25454V6.33526H4V9.06528H6.37437V15.6653C6.85107 15.7409 7.33872 15.7797 7.83551 15.7797C8.3323 15.7797 8.81996 15.7409 9.29666 15.6653V9.06528H11.4756Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default FacebookIcon;
